/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client } from "../client";
import type { ResourceCollection } from "../resources";
import type { DocumentTypeResource, EventAgentResource, EventCategoryResource, EventGroupResource, EventResource } from "../resources/eventResource";
import type { ListArgs } from "./basicRepository";
import { MixedScopeBaseRepository } from "./mixedScopeBaseRepository";
interface EventListArgs extends ListArgs {
    from?: string;
    to?: string;
    fromAutoId?: number;
    toAutoId?: number;
    asCsv?: boolean;
    regarding?: string[];
    regardingAny?: string[];
    includeSystem?: string;
    internal?: boolean;
    users?: string[];
    projects?: string[];
    projectGroups?: string[];
    environments?: string[];
    eventGroups?: string[];
    eventCategories?: string[];
    eventAgents?: string[];
    tenants?: string[];
    tags?: string[];
    documentTypes?: string[];
    excludeDifference?: boolean;
}
export class EventRepository extends MixedScopeBaseRepository<EventResource, EventResource, EventListArgs> {
    constructor(client: Client) {
        super("Events", client);
    }
    categories(options: any): Promise<EventCategoryResource[]> {
        return this.client.get<EventCategoryResource[]>(this.client.getLink("EventCategories"), options);
    }
    groups(options: any): Promise<EventGroupResource[]> {
        return this.client.get<EventGroupResource[]>(this.client.getLink("EventGroups"), options);
    }
    documentTypes(options: any): Promise<DocumentTypeResource[]> {
        return this.client.get<DocumentTypeResource[]>(this.client.getLink("EventDocumentTypes"), options);
    }
    eventAgents(): Promise<EventAgentResource[]> {
        return this.client.get<EventAgentResource[]>(this.client.getLink("EventAgents"));
    }
    getUnpaginatedEvents(args?: EventListArgs): Promise<ResourceCollection<EventResource>> {
        const template = "~/bff/events{?regarding,regardingAny,user,users,projects,projectGroups,environments,eventGroups,eventCategories,eventAgents,tags,tenants,from,to,internal,fromAutoId,toAutoId,documentTypes,asCsv,ids,spaces,includeSystem,excludeDifference}";
        return this.client.get<ResourceCollection<EventResource>>(template, super.extend(this.spacePartitionParameters(), args));
    }
}
